/** Turns a story's embed URL into its play URL, keeping any query string the URL already has. */
export function withAutoplayParam(embedUrl: string): string {
	const url = new URL(embedUrl);
	url.searchParams.set('autoplay', '1');
	return url.toString();
}
